import studio from './studio';

const componentsByWhitelabel: Record<string, any> = { studio };
export default componentsByWhitelabel;
